export default __webpack_public_path__ + "static/media/19.c42aa0d7.jpg";